import { StyleSheet } from "@react-pdf/renderer"


export const customerDataStyles = () => {

    const customerData = StyleSheet.create({
        container: {
            height:80,
            alignSelf: 'center',
            borderWidth: 1,
            flexDirection: 'row',
            marginTop:2,
        },
        firstSubContainer: {
            width: '50%',
            height: '100%',
            flexDirection: 'column',
            borderRightWidth: 1,
        },
        secondSubContainer: {
            width: '50%',
            height: '100%',
            flexDirection: 'column',
        },
        titleContainer: {
            width: '100%',
            height: '15%',
            justifyContent: 'center',
            borderBottomWidth: 1,
            alignItems:'center'
        },
        title: {
            fontSize: 7,
            fontWeight: 700
        },
        dataContainer: {
            width: '100%',
            height: '80%',
            flexDirection: 'row'
        },
        firstContainer: {
            width: '45%',
            flexDirection: 'column',
            justifyContent: 'space-between',
            padding: 5,

        },
        secondContainer: {
            width: '50%',
            flexDirection: 'column',
            justifyContent: 'space-between',
            padding: 5,
            gap: 5
        },
        field: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            flexWrap:'wrap'
        },
        concept: {
            fontSize: 6,
            fontWeight: 700
        },
        data: {
            fontSize: 6,
        }
    })


    return {
        customerData
    }
}